import React, { memo, useMemo } from "react";

import "./product-card-details.css";
import { genClassName } from "@disco/disco_core";

const ProductCardDetails = memo(
	({ product, brand, prefixBrandName = false }) => {
		const { name = "" } = useMemo(() => product || {}, [product]);
		const { name: brandName = "" } = brand || {};

		const productName = prefixBrandName ? `${brandName} ${name}` : name;

		return (
			<div
				className={genClassName({
					base: "widget-product-details",
				})}
			>
				<div className="widget-product-title">{productName}</div>
			</div>
		);
	}
);
export default ProductCardDetails;
